import React from "react";
import TableData from "./TableData";
import TableHeadings from "./tableHeadings";
import classes from "./table.module.css";
import { Typography } from "antd";
const { Paragraph } = Typography;
const Table = ({
  datas,
  headings,
  layoverSwitch,
  responses,
  onQuesChange,
  editable,
}) => {
  const dataKeys = Object.keys(headings);
  const tableHeadings = dataKeys.map((key) => {
    if (key === "kebab")
      return (
        <TableHeadings>
          <i class="fas fa-ellipsis-v"></i>
        </TableHeadings>
      );
    return <TableHeadings>{key}</TableHeadings>;
  });

  const data = datas.map((data, index) => {
    return (
      <tr className={[classes.dataRow, classes.row].join(" ")}>
        {dataKeys.map((key) => {
          if (key === "s no.") return <TableData>{index + 1}</TableData>;

          else if (key === "select response"){
            console.log("response",data[headings[key]])
            return (
              <TableData>
                {responses ? responses[data[headings[key]]](data["_id"]) : null}
              </TableData>
            );}
          else if (key === "response"){
            console.log("response",data[headings[key]])
            return (
              <TableData>
                {responses ? responses[data[headings[key]]] : null}
              </TableData>
            );}
          else if (key === "kebab")
            return (
              <TableData>
                <i
                  onClick={() => layoverSwitch(index)}
                  className={[classes.kebab, "fas fa-ellipsis-v"].join(" ")}
                ></i>
              </TableData>
            );
          else if(key==="audit action")
          return(
      
              <p className={classes.question}>{data[headings[key]]}</p>
            
          )
          else if (key === "audit question")
            return (
              <TableData>
                {/* <input
                className={classes.question}
                  onChange = {(e)=>onQuesChange(e, index)}
                  value = {data[headings[key]]}
                  placeholder="Type question here. "

                /> */}
                {editable ? (
                  <Paragraph
                    className={classes.question}
                    editable={{
                      autoSize: { maxRows: 3 },
                      onChange: (e) => onQuesChange(e, index),
                    }}
                  >
                    {data[headings[key]]}
                  </Paragraph>
                ) : (
                  <p className={classes.question}>{data[headings[key]]}</p>
                )}
              </TableData>
            );
          return <TableData>{data[headings[key]]}</TableData>;
        })}
      </tr>
    );
  });
  return (
    <table className={classes.table}>
      {
        <tr className={[classes.headRow, classes.row].join(" ")}>
          {tableHeadings}
        </tr>
      }
      {data}
    </table>
  );
};

export default Table;
